//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import goTo from 'vuetify/lib/services/goto'
export default {
  name: 'Artists',
  data: () => ({
    cardsFeatures: [
      {
        title: 'No tech knowledge required',
        subtitle: `Get your artwork ready and ArtForge will handle the rest!. <br/><br/>Try out generating your artwork in our free generative artwork sandbox!`,
      },
      {
        title: 'Rarity Ranking',
        subtitle: `ArtForge ranks tokens according to their rarity based
          on their attributes. Collectors often use this feature to estimate the value of
          tokens for secondary sales`,
      },
      {
        title: 'Rarity Weights',
        subtitle: `Artists can set rarity weights to certain traits to influence their rarity.
          This feature is useful when artists want to make certain traits more rare than others.`,
      },
      {
        title: 'Credit Card Support',
        subtitle: `By dropping your collection on ArtForge, you expand your potential market size by
          allowing non-crypto-savvy users to participate and acquire crypto right from ArtForge without
          having to jump through multiple hoops and lengthy KYCs.`,
      },
      {
        title: 'Objkt.com Auto-Listing',
        subtitle: `In addition to the ArtForge market, your collection will be auto-listed on the very popular Objkt.com market.`,
      },
      {
        title: 'Advanced search and filtering',
        subtitle: `ArtForge offers a smooth and efficient user experiences to
          both collectors and artists alike with plenty of features to better showcase collections
          and tokens.`,
      },
      {
        title: 'A flat 2.5% fee',
        subtitle: `Launching on ArtForge will cost a flat 2.5% fee on primary and secondary sales.`,
      },
    ],
  }),
  computed: {
    userAddress() {
      if (this.$auth.user) return this.$auth.user.wallet

      return null
    },
    userAlias() {
      if (this.$auth.user) return this.$auth.user.username

      return ''
    },
  },
  methods: {
    launch() {
      if (!this.userAddress) {
        this.$store.dispatch('addSnackbar', {
          text: `Please Sign in.`,
          type: 'error',
        })
        goTo(0)
        // return
      } else {
        const go = `/profile/${this.userAlias}/collections`
        this.$router.push(go)
      }
    },
  },
}
